import { useDroppable } from '@dnd-kit/core';
import Sprite from '@/shared/GameComponents/GameObjects/Sprite/Sprite';

export default function DroppableSprite({
  img,
  over,
  isLastCorrect,
  debug,
  onClick,
  className,
}) {
  const { setNodeRef } = useDroppable({
    id: img.id,
  });

  return (
    <Sprite
      onClick={onClick}
      innerRef={setNodeRef}
      spriteId={img.atlasImg || img.id}
      transform={img.transform}
      spriteScale={over ? 1.2 : 1}
      debug={debug}
      className={`${className ? className : 'user-interaction-none'} ${
        isLastCorrect ? 'last-correct' : ''
      }`}
    />
  );
}
